import React from "react";
import { useParams, useLocation } from "react-router-dom";
import useCheckoutPage from "./hooks/useCheckoutPage";
import { resolveTemplate } from "./templates/registry";
import "./checkoutPage.css";

export default function CheckoutPageContainer() {
  const { pageId } = useParams();
  const location = useLocation();
  const accessToken = new URLSearchParams(location.search).get("accessToken");

  const { data, loading, error, reload } = useCheckoutPage(pageId, accessToken);

  if (loading) {
    return (
      <div className="ck-state">
        <h2>Loading…</h2>
        <div>Fetching this checkout page.</div>
      </div>
    );
  }

  if (error || !data) {
    // getPublicPage 404s for both "no such page" and "not active", which is the
    // right thing to show a buyer either way.
    const notFound = !error || error.status === 404;
    return (
      <div className="ck-state">
        <h2>{notFound ? "This page isn't available" : "Something went wrong"}</h2>
        <div>
          {notFound
            ? "The checkout link may be incorrect, or the page is no longer active."
            : error.message}
        </div>
        {/* A 404 won't fix itself, so only a transient failure gets a retry.
            The endpoint is rate-limited, which is why this is a deliberate
            user action rather than an automatic retry in the hook. */}
        {!notFound && (
          <button className="ck-retry" onClick={reload}>
            Try again
          </button>
        )}
      </div>
    );
  }

  // Defensive: everything downstream is null-safe, so this destructure is the
  // only remaining white-screen path if the envelope ever arrives without page.
  const { page = {}, config = {}, products = [], affiliate = null } = data;
  const templateId = page.presentation && page.presentation.templateId;
  const { Template } = resolveTemplate(templateId);

  return (
    <Template
      page={page}
      config={config}
      products={products}
      pageId={pageId}
      accessToken={accessToken}
      affiliate={affiliate}
    />
  );
}
